import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { StatsLayout } from '@/widgets/stats-layout'

export const Route = createFileRoute('/_dashboard/_stats-layout')({
    component: StatsLayout,
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager])) {
            throw redirect({
                to: '/recruitment',
                search: { page: 1 },
            })
        }
    },
    onEnter: () => {
        document.title = 'Taxoparkee - Статистика'
    },
})
